/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/state-in-constructor */
import '../../config';
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import axios from 'axios';
import ls from 'local-storage';
import _ from 'lodash';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import VisibilitySensor from 'react-visibility-sensor';
import OlsBottomNav from '../../container/OlsBottomNav/OlsBottomNav';
import OlsProductGrid from '../../component/OlsProductGrid/OlsProductGrid';
import OlsSearchSort from '../../container/OlsSearch/OlsSearchSort';
import OlsBannerImageSlider from '../../container/OlsBannerImageSlider/OlsBannerImageSlider';
import WhatsAppLink from '../../component/WhatsAppLink/WhatsAppLink';
import OlsItemEdit from '../../container/OlsItemEdit/OlsItemEdit';
import OlsProductView from '../../container/OlsProductView/OlsProductView';
import Divider from '@material-ui/core/Divider';
import SortByIcon from '../../component/SortByIcon/SortByIcon';
import Grid from '@material-ui/core/Grid';
import SelectAllOutlinedIcon from '@material-ui/icons/SelectAllOutlined';
import OlsCategorySelect from '../../container/OlsCategorySelect/OlsCategorySelect';
import OlsFooter from '../../component/OlsFooter/OlsFooter';
import OlsNavbar from '../../component/OlsNavbar/OlsNavbar';
import FacebookLink from '../../component/FacebookLink/FacebookLink';
import OlsPostGrid from '../../component/OlsPostGrid/OlsPostGrid';
import { Link } from 'react-router-dom';

let isMounted = false;

const useStyles = (theme) => ({
  displayMobile: {
    display: 'block',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  displayDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },
  page: {
    backgroundColor : theme.palette.color.background,
    maxWidth: theme.palette.width.appWidth,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  loadingTop: {
    height: 5,
    width: '100%',
    position: 'fixed',
    top: 0,
    left: 'auto',
    right: 'auto',
    paddingRight: '0px !important',
    zIndex: 1101,
  },
  postList: {
    padding: 4,
    display: 'block',
    '&::after': {
      content: '""',
      clear: 'both',
      display: 'table',
    },
  },
  content: {
    padding: 4,
    display: 'block',
    minHeight: 1000,
    '&::after': {
      content: '""',
      clear: 'both',
      display: 'table',
    },
  },

  
});

let base_url  = global.config.host;
if(base_url.length<1){
    base_url  = window.location.origin;
}
const { pathname }  = window.location;
const arrPath       = pathname.split('/');
let urlid = (arrPath && arrPath.length >= 2) ? arrPath[2] : '';
ls.set('urlid', urlid);

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usr_info: ls.get('usr_info') || false,
      otl_info: ls.get(`${urlid}_info`) || {},
      banners: ls.get(`${urlid}_banners`) || [],
      order_info: ls.get(`${urlid}_ShoppingCart_OrderInfo`) || {},
      item_list: [],
      loading: false,
      more: false,
      post_list: ls.get(`${urlid}_post_list`) || [],
      category_list: ls.get(`${urlid}_categorys`) || [],
      product_list: ls.get(`${urlid}_product_list`) || [],
      search_text: '',
      itemEdit: false,
      itemEditData: {},
      itemView: false,
      itemViewData: {},
    };
    this.isProductBest    = ls.get('isProductBest') || false;
    this.categorySelected = '';
  }

  componentDidMount() {
    isMounted = true;
    
    urlid = ls.get('urlid') || '';
    let otl_info = ls.get(`${urlid}_info`) || {};
    this.setState({
      otl_info: otl_info
    });

    let usr_info = ls.get('usr_info') || false;
    this.setState({
      usr_info: usr_info
    });
    if(usr_info!==false){
      if(_.isString(usr_info.usr_uxid)){
        const lsShoppingCartOrderInfo = `${urlid}_ShoppingCart_OrderInfo`;
        const lsShoppingCartItemList = `${urlid}_ShoppingCart_ItemList`;
        const orderInfo = ls.get(lsShoppingCartOrderInfo);
        if (_.isObject(orderInfo)) {
          if (_.isString(orderInfo.order_from_uxid)) {
            if(orderInfo.order_from_uxid===usr_info.usr_uxid){
              this.setState({ order_info: orderInfo });
              const itemList = ls.get(lsShoppingCartItemList);
              if (_.isArray(itemList)) {
                this.setState({ item_list: itemList });
              }
            }
          }
        }
      }
    }
    
    this.otlBannersInit(otl_info);
    this.pageInfo();
    //this.otlInfo();
    //this.doListLoad();
    //this.otlOrderInfo();
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    isMounted = false;
  }

  otlBannersInit = (otl) => {
    if (_.isString(otl.otl_name)) {
      document.title = otl.otl_name;
    }

    let otlBanners = [];

    if (_.isString(otl.otl_banner1)) {
      otlBanners.push(otl.otl_banner1);
    }
    if (_.isString(otl.otl_banner2)) {
      otlBanners.push(otl.otl_banner2);
    }
    if (_.isString(otl.otl_banner3)) {
      otlBanners.push(otl.otl_banner3);
    }
    if (_.isString(otl.otl_banner4)) {
      otlBanners.push(otl.otl_banner4);
    }

    if (_.size(otlBanners) > 0) {
      this.setState({
        banners: otlBanners
      });
    } else {

      otlBanners.push(base_url+'/files/banner/no_banner.png');
      otlBanners.push(base_url+'/files/banner/no_banner.png');
      otlBanners.push(base_url+'/files/banner/no_banner.png');
      otlBanners.push(base_url+'/files/banner/no_banner.png');

      this.setState({
        banners: otlBanners
      });
    }

    urlid = ls.get('urlid') || '';
    ls.set(`${urlid}_banners`, otlBanners);
  }

  pageInfo = () => {
    this.setState({ loading: true });
    urlid = ls.get('urlid') || '';
    const lsShoppingCartOrderInfo = `${urlid}_ShoppingCart_OrderInfo`;
    const lsShoppingCartItemList  = `${urlid}_ShoppingCart_ItemList`;
    const formdatau = new FormData();
    formdatau.append('urlid', urlid);
    axios.post(base_url+'/olshop_api/page/info/', formdatau).then((response) => {
      if (isMounted) {
        this.setState({ loading: false });
        if (_.isObject(response.data.usr_info)) {
          this.setState({ usr_info: response.data.usr_info });
          ls.set('usr_info', response.data.usr_info);
        }
        if (_.isObject(response.data.otl_info)) {
          urlid = response.data.otl_info.otl_urlid;
          this.setState({
            otl_info: response.data.otl_info,
          });
          ls.set('urlid', urlid);
          ls.set(`${urlid}_info`, response.data.otl_info);
          this.otlBannersInit(response.data.otl_info);
        }
        if (_.isObject(response.data.order_info)) {
          const orderInfoResp = response.data.order_info;
          if (_.isString(orderInfoResp.order_uxid)) {
            this.setState({ order_info: orderInfoResp });
            ls.set(lsShoppingCartOrderInfo, orderInfoResp);
          }
        }
        if (_.isArray(response.data.item_list)) {
          const itemListResp = response.data.item_list;
          this.setState({ item_list: itemListResp });
          ls.set(lsShoppingCartItemList, itemListResp);
        }
        this.doListLoad();
      }
    });
  }

  otlInfo = () => {
    urlid = ls.get('urlid') || '';
    const formdatau = new FormData();
    formdatau.append('urlid', urlid);
    axios.post(base_url+'/olshop_api/otl/otl_info/', formdatau).then((response) => {
      if (isMounted) {
        if (_.isObject(response.data.otl_info)) {
          let urlid_old = urlid;
          urlid = response.data.otl_info.otl_urlid;
          this.setState({
            otl_info: response.data.otl_info,
          });
          ls.set('urlid', urlid);
          ls.set(`${urlid}_info`, response.data.otl_info);
          this.otlBannersInit(response.data.otl_info);
          if(urlid!==urlid_old){
            this.doListLoad();
          }
        }
      }
    });
  }

  otlOrderInfo = () => {
    urlid = ls.get('urlid') || '';
    const lsShoppingCartOrderInfo = `${urlid}_ShoppingCart_OrderInfo`;
    const lsShoppingCartItemList  = `${urlid}_ShoppingCart_ItemList`;
    this.setState({ loading: true });
    const formdatao = new FormData();
    formdatao.append('urlid', urlid);
    axios.post(base_url+'/olshop_api/order/order_info/', formdatao).then((response) => {
      if (isMounted) {
        this.setState({ loading: false });
        if (_.isObject(response.data.order_info)) {
          const orderInfoResp = response.data.order_info;
          if (_.isString(orderInfoResp.order_uxid)) {
            this.setState({ order_info: orderInfoResp });
            ls.set(lsShoppingCartOrderInfo, orderInfoResp);
          }
        }
        if (_.isArray(response.data.item_list)) {
          const itemListResp = response.data.item_list;
          this.setState({ item_list: itemListResp });
          ls.set(lsShoppingCartItemList, itemListResp);
        }
      }
    });
  }

  productViewOpen = (data) => {
    if (isMounted) {
      if (_.isObject(data)) {
        if (_.isString(data.product_uxid)) {
          urlid = ls.get('urlid') || '';
          const uxid = data.product_uxid;
          const productViewTemp = `${urlid}_product_${uxid}`;
          ls.set(productViewTemp, data);
          this.props.history.push(`/product/${urlid}/${uxid}`);
        }
      }
    }
  }

  handleCategorySelect = (value) => {
    if (isMounted) {
      this.categorySelected = value;
      this.doListLoad();
    }
  }

  handleSearchOnChange = (value) => {
    if (isMounted) {
      if(value.length){
        this.setState({
          search_text: value,
        });
        this.setState({ loading: true });
        urlid = ls.get('urlid') || '';
        const formdataps = new FormData();
        formdataps.append('urlid', urlid);
        formdataps.append('category_name', this.categorySelected);
        formdataps.append('search', value);
        formdataps.append('last_count', 0);
        axios.post(base_url+'/olshop_api/product/product_search/', formdataps).then((response) => {
          if (isMounted) {
            this.setState({ loading: false });
            if (_.isArray(response.data.product_list)) {
              this.setState({
                product_list: response.data.product_list,
              });
            }
          }
        });
      } else {
        this.doListLoad();
      }
    }
  }

  handleSearchOnSubmit = (value) => {
    if (isMounted) {
      if(value.length){
        this.setState({
          search_text: value,
        });
        this.setState({ loading: true });
        urlid = ls.get('urlid') || '';
        const formdataps = new FormData();
        formdataps.append('urlid', urlid);
        formdataps.append('category_name', this.categorySelected);
        formdataps.append('search', value);
        formdataps.append('last_count', 0);
        axios.post(base_url+'/olshop_api/product/product_search/', formdataps).then((response) => {
          if (isMounted) {
            this.setState({ loading: false });
            if (_.isArray(response.data.product_list)) {
              this.setState({
                product_list: response.data.product_list,
              });
            }
          }
        });
        window.scrollTo(0, 0);
      } else {
        this.doListLoad();
      }
    }
  }

  handleShoppingCartOpen = () => {
    if (isMounted) {
      urlid = ls.get('urlid') || '';
      const lsShoppingCartOrderInfo = `${urlid}_ShoppingCart_OrderInfo`;
      const lsShoppingCartItemList = `${urlid}_ShoppingCart_ItemList`;
      ls.set(lsShoppingCartOrderInfo, this.state.order_info);
      ls.set(lsShoppingCartItemList, this.state.item_list);
      this.props.history.push('/shoppingcart');
    }
  }

  doListLoad = () => {
    if (isMounted) {
      urlid = ls.get('urlid') || '';
      const formdatapost = new FormData();
      formdatapost.append('urlid', urlid);
      axios.post(base_url+'/olshop_api/post/post_home/', formdatapost).then((response) => {
        if (isMounted) {
          if (_.isArray(response.data.post_list)) {
            this.setState({
              post_list: response.data.post_list,
            });
            ls.set(`${urlid}_post_list`, response.data.post_list);
          }
        }
      });

      const lastCount = 0;
      this.setState({ loading: true });
      urlid = ls.get('urlid') || '';
      const formdatapl = new FormData();
      formdatapl.append('urlid', urlid);
      formdatapl.append('category_name', this.categorySelected);
      formdatapl.append('last_count', lastCount);
      if(this.isProductBest){
        axios.post(base_url+'/olshop_api/product/product_best_list/', formdatapl).then((response) => {
          if (isMounted) {
            this.setState({ loading: false });
            if (_.isArray(response.data.product_list)) {
              if (_.size(response.data.product_list) > 0) {
                this.setState({
                  more: true,
                });
              } else {
                this.setState({
                  more: false,
                });
              }
              this.setState({
                product_list: response.data.product_list,
              });
              ls.set(`${urlid}_product_list`, response.data.product_list);
            }
          }
        });
      } else {
        axios.post(base_url+'/olshop_api/product/product_list/', formdatapl).then((response) => {
          if (isMounted) {
            this.setState({ loading: false });
            if (_.isArray(response.data.product_list)) {
              if (_.size(response.data.product_list) > 0) {
                this.setState({
                  more: true,
                });
              } else {
                this.setState({
                  more: false,
                });
              }
              this.setState({
                product_list: response.data.product_list,
              });
              ls.set(`${urlid}_product_list`, response.data.product_list);
            }
          }
        });
      }
      const formdatac = new FormData();
      formdatac.append('urlid', urlid);
      formdatac.append('last_count', 0);
      axios.post(base_url+'/olshop_api/product/product_category_list/', formdatac).then((response) => {
        if (isMounted) {
          if (_.isArray(response.data.categorys)) {
            this.setState({
              category_list: response.data.categorys,
            });
            ls.set(`${urlid}_categorys`, response.data.categorys);
          }
        }
      });
      window.scrollTo(0, 0);
    }
  }

  doListMore = () => {
    if (isMounted) {
      const lastCount = _.size(this.state.product_list);
      urlid = ls.get('urlid') || '';
      const formdatapl = new FormData();
      formdatapl.append('urlid', urlid);
      formdatapl.append('category_name', this.categorySelected);
      formdatapl.append('last_count', lastCount);
      if(this.isProductBest){
        axios.post(base_url+'/olshop_api/product/product_best_list/', formdatapl).then((response) => {
          if (isMounted) {
            if (_.isArray(response.data.product_list)) {
              if (_.size(response.data.product_list) > 0) {
                this.setState({
                  more: true,
                });
                const productList = _.unionBy(this.state.product_list, response.data.product_list, 'product_uxid');
                this.setState({
                  product_list: productList,
                });
              } else {
                this.setState({
                  more: false,
                });
              }
            }
          }
        });
      } else {
        axios.post(base_url+'/olshop_api/product/product_list/', formdatapl).then((response) => {
          if (isMounted) {
            if (_.isArray(response.data.product_list)) {
              if (_.size(response.data.product_list) > 0) {
                this.setState({
                  more: true,
                });
                const productList = _.unionBy(this.state.product_list, response.data.product_list, 'product_uxid');
                this.setState({
                  product_list: productList,
                });
              } else {
                this.setState({
                  more: false,
                });
              }
            }
          }
        });
      }
    }
  }

  doSearchMore = () => {
    if (isMounted) {
      const lastCount = _.size(this.state.product_list);
      urlid = ls.get('urlid') || '';
      const formdataps = new FormData();
      formdataps.append('urlid', urlid);
      formdataps.append('category_name', this.categorySelected);
      formdataps.append('search', this.state.search_text);
      formdataps.append('last_count', lastCount);
      axios.post(base_url+'/olshop_api/product/product_search/', formdataps).then((response) => {
        if (isMounted) {
          if (_.isArray(response.data.product_list)) {
            if (_.size(response.data.product_list) > 0) {
              this.setState({
                more: true,
              });
              const productList = _.unionBy(this.state.product_list, response.data.product_list, 'product_uxid');
              this.setState({
                product_list: productList,
              });
            } else {
              this.setState({
                more: false,
              });
            }
          }
        }
      });
    }
  }

  handleLoadMore = (isMore) => {
    if (isMore) {
      this.setState({
        more: true,
      });
      if (_.isEmpty(this.state.search_text)) {
        this.doListMore();
      } else {
        this.doSearchMore();
      }
    }
  }

  handleItemEditClose = () => {
    if (isMounted) {
      this.setState({
        itemEdit: false,
      });
    }
  }

  handleItemEditDelete = (fields) => {
    if (isMounted) {
      this.setState({
        itemEdit: false,
      });
      urlid = ls.get('urlid') || '';
      const lsShoppingCartOrderInfo = `${urlid}_ShoppingCart_OrderInfo`;
      const lsShoppingCartItemList = `${urlid}_ShoppingCart_ItemList`;
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('item_uxid', fields.item_uxid);
      formdata.append('item_amount', fields.item_amount);
      formdata.append('item_note', fields.item_note);
      axios.post(base_url+'/olshop_api/order/item_delete/', formdata).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.order_info)) {
            const orderInfoResp = response.data.order_info;
            if (_.isString(orderInfoResp.order_uxid)) {
              this.setState({ order_info: orderInfoResp });
              ls.set(lsShoppingCartOrderInfo, orderInfoResp);
            }
          }
          if (_.isArray(response.data.item_list)) {
            const itemListResp = response.data.item_list;
            this.setState({ item_list: itemListResp });
            ls.set(lsShoppingCartItemList, itemListResp);
          }
          //= toast start
          if (_.isString(response.data.status)) {
            if (response.data.status === 'OK') {
              if (_.isString(response.data.message)) {
                const { message } = response.data;
                this.toastShow('success', message);
              }
            } else if (_.isString(response.data.message)) {
              const { message } = response.data;
              this.toastShow('error', message);
            }
          }
          //= toast end
        }
      });
    }
  }

  handleItemEditSave = (fields) => {
    if (isMounted) {
      this.setState({
        itemEdit: false,
      });
      urlid = ls.get('urlid') || '';
      const lsShoppingCartOrderInfo = `${urlid}_ShoppingCart_OrderInfo`;
      const lsShoppingCartItemList = `${urlid}_ShoppingCart_ItemList`;
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('item_uxid', fields.item_uxid);
      formdata.append('item_amount', fields.item_amount);
      formdata.append('item_note', fields.item_note);
      axios.post(base_url+'/olshop_api/order/item_update/', formdata).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.order_info)) {
            const orderInfoResp = response.data.order_info;
            if (_.isString(orderInfoResp.order_uxid)) {
              this.setState({ order_info: orderInfoResp });
              ls.set(lsShoppingCartOrderInfo, orderInfoResp);
            }
          }
          if (_.isArray(response.data.item_list)) {
            const itemListResp = response.data.item_list;
            this.setState({ item_list: itemListResp });
            ls.set(lsShoppingCartItemList, itemListResp);
          }
          //= toast start
          if (_.isString(response.data.status)) {
            if (response.data.status === 'OK') {
              if (_.isString(response.data.message)) {
                const { message } = response.data;
                this.toastShow('success', message);
              }
            } else if (_.isString(response.data.message)) {
              const { message } = response.data;
              this.toastShow('error', message);
            }
          }
          //= toast end
        }
      });
    }
  }

  handleItemViewOpen = (productOpen) => {
    if (isMounted) {
      this.setState({
        itemViewData: productOpen,
        itemView: true,
      });
    }
  }

  handleItemViewClose = () => {
    if (isMounted) {
      this.setState({
        itemView: false,
      });
    }
  }

  handleItemViewBuy = (productBuy) => {
    if (isMounted) {
      this.setState({
        itemView: false,
      });
      urlid = ls.get('urlid') || '';
      const usrInfo = ls.get('usr_info');
      if (_.isString(usrInfo.usr_realname)) {
        if (_.isString(this.state.order_info.order_uxid)) { // untuk memastikan object order terload dengan benar
          if (_.isString(productBuy.product_uxid)) { // untuk memastikan object product terload dengan benar
            const item = _.find(this.state.item_list, { item_product_uxid: productBuy.product_uxid });
            if (_.isObject(item)) {
              if (this.state.order_info.order_step === 'DIBUAT') {
                this.setState({
                  itemEdit: true,
                  itemEditData: item,
                });
              } else {
                this.toastShow('error', 'Tidak dapat beli produk ini');
              }
            } else {
              const lsShoppingCartOrderInfo = `${urlid}_ShoppingCart_OrderInfo`;
              const lsShoppingCartItemList = `${urlid}_ShoppingCart_ItemList`;
              this.setState({ loading: true });
              urlid = ls.get('urlid') || '';
              const formdata = new FormData();
              formdata.append('item_order_uxid', this.state.order_info.order_uxid);
              formdata.append('item_product_uxid', productBuy.product_uxid);
              formdata.append('item_amount', 1);
              formdata.append('item_note', '');
              axios.post(base_url+'/olshop_api/order/item_add/', formdata).then((response) => {
                if (isMounted) {
                  this.setState({ loading: false });
                  if (_.isObject(response.data.order_info)) {
                    const orderInfoResp = response.data.order_info;
                    if (_.isString(orderInfoResp.order_uxid)) {
                      this.setState({ order_info: orderInfoResp });
                      ls.set(lsShoppingCartOrderInfo, orderInfoResp);
                    }
                  }
                  if (_.isArray(response.data.item_list)) {
                    const itemListResp = response.data.item_list;
                    this.setState({ item_list: itemListResp });
                    ls.set(lsShoppingCartItemList, itemListResp);
                  }
                  //= toast start
                  if (_.isString(response.data.status)) {
                    if (response.data.status === 'OK') {
                      if (_.isString(response.data.message)) {
                        const { message } = response.data;
                        this.toastShow('success', message);
                      }
                    } else if (_.isString(response.data.message)) {
                      const { message } = response.data;
                      this.toastShow('error', message);
                    }
                  }
                  //= toast end
                  const itemEd = _.find(this.state.item_list, { item_product_uxid: productBuy.product_uxid });
                  if (_.isObject(itemEd)) {
                    if (this.state.order_info.order_step === 'DIBUAT') {
                      this.setState({
                        itemEdit: true,
                        itemEditData: itemEd,
                      });
                    } else {
                      this.toastShow('error', 'Tidak dapat beli produk ini');
                    }
                  }
                }
              });
            }
          }
        }
      } else {
        this.props.history.push('/login');
      }
    }
  };

  handleSearchIconOnSort= (value) => {
    if (isMounted) {
      this.isProductBest = value;
      ls.set('isProductBest', value);
      this.doListLoad();
    }
  }

  render() {
    const { classes } = this.props;
    return (
        <div style={{ paddingBottom: 56 }} >
          <OlsBannerImageSlider data={this.state.banners} />
          <div className={classes.page}>
                <div style={_.size(this.state.post_list)>0 ? { paddingTop: 5 } : { display: 'none' }} >
                  <Grid container justify="space-between">
                    <Grid item>
                      <Grid item container direction="column" justify="center" alignItems="flex-start">
                        <Grid item>
                          <Typography style={{ fontSize: 14, marginLeft: 5}} variant="overline" gutterBottom noWrap>
                          Posting
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <Grid item container direction="column" justify="center">
                        <Grid item>
                          <div style={{ paddingTop: 5 }} >

                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <Grid item container direction="column" justify="center" alignItems="flex-end">
                        <Grid item>
                          <Typography style={{ fontSize: 14, marginRight: 5}} variant="overline" gutterBottom noWrap>
                            <Link to="/posts" >
                            Lihat Semua
                            </Link>
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>

                <div style={_.size(this.state.post_list)>0 ? {} : { display: 'none' }} >
                  <div className={classes.postList} >
                    {
                      this.state.post_list.map((post) => <OlsPostGrid key={post.post_uxid} data={post} />)
                    }
                  </div>
                </div>

              <div className={classes.displayMobile}  >
                <OlsCategorySelect data={this.state.category_list} onSelect={this.handleCategorySelect} />
                <OlsSearchSort value={this.isProductBest} onChange={this.handleSearchOnChange} onSubmit={this.handleSearchOnSubmit} onSort={this.handleSearchIconOnSort} />
              </div>

              <div className={classes.displayDesktop} >
                <div style={{ paddingTop: 15, paddingBottom: 5 }} >
                  <Grid container justify="space-between">
                    <Grid item>
                      <Grid item container direction="column" justify="center" alignItems="flex-start">
                        <Grid item>
                          <div style={{ paddingTop: 5 }} >
                            <Grid container item >
                              <Grid item >
                              <SelectAllOutlinedIcon style={{ fontSize: 36 }} />
                              </Grid>
                              <Grid item >
                                <Typography style={{ fontSize: 14, marginLeft: 5}} variant="overline" gutterBottom noWrap>
                                  Daftar Produk
                                </Typography>
                              </Grid>
                            </Grid>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <Grid item container direction="column" justify="center">
                        <Grid item>
                          <div style={{ paddingTop: 5 }} >
                          <OlsCategorySelect type="label" data={this.state.category_list} onSelect={this.handleCategorySelect} />
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <Grid item container direction="column" justify="center" alignItems="flex-end">
                        <Grid item>
                        <SortByIcon value={this.isProductBest} onSort={this.handleSearchIconOnSort} />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </div>
            
            
            
            <div className={classes.content}>
              {
                this.state.product_list.map((product) => <OlsProductGrid key={product.product_uxid} data={product} onSelect={(data) => this.handleItemViewOpen(data)} />)
              }
            </div>
            
          </div>

          <VisibilitySensor onChange={this.handleLoadMore}>
            <div>
              <div style={{ height: 5 }}>
                <LinearProgress style={this.state.more ? {} : { display: 'none' }} />
              </div>
            </div>
          </VisibilitySensor>
          
          <Divider />

          <OlsFooter outlet={this.state.otl_info} />

          <div className={classes.displayMobile} >
            <WhatsAppLink phone={this.state.otl_info.otl_whatsapp} label="Butuh Bantuan ?" text={this.state.otl_info.otl_name ? `Hallo ${this.state.otl_info.otl_name}` : 'Hallo'} />
          </div>

          <FacebookLink url={this.state.otl_info.otl_link_fb ? this.state.otl_info.otl_link_fb : ''} />
          
          <OlsProductView data={this.state.itemViewData} urlid={urlid} onClose={this.handleItemViewClose} onBuy={this.handleItemViewBuy} open={this.state.itemView} />
          <OlsItemEdit data={this.state.itemEditData} onClose={this.handleItemEditClose} onSave={this.handleItemEditSave} onDelete={this.handleItemEditDelete} open={this.state.itemEdit} />
          
          <OlsNavbar 
            value="home" 
            title={this.state.otl_info.otl_name ? this.state.otl_info.otl_name : 'Home'}
            text={this.state.otl_info.otl_name ? `Hallo ${this.state.otl_info.otl_name}` : 'Hallo'}
            outlet={this.state.otl_info} 
            itemCount={_.size(this.state.item_list)} 
            onCartClick={this.handleShoppingCartOpen} 
            onSearchChange={this.handleSearchOnChange} 
            onSearchSubmit={this.handleSearchOnSubmit}
            />

          <div className={classes.displayMobile} >
            <OlsBottomNav value="home" />
          </div>

          <div className={classes.loadingTop} >
            <LinearProgress style={this.state.loading ? {} : { display: 'none' }} />
          </div>
        </div>
    );
  }
}

export default withStyles(useStyles)(Home);
